import * as Model from '../model/types';
import {ServerAPI} from '../serverApi';
import {Cache} from '../cache';
import {Engine, BasicEngine} from '../engine';
import {Server} from './types';
import {Tracer} from '../trace';

export class LocalServer implements Server {
  private readonly engine: Engine;
  constructor(cache: Cache, backend: ServerAPI, trace?: Tracer) {
    this.engine = new BasicEngine(cache, backend, {
      trace,
    });
  }

  query(nodes: Model.Node[]): Promise<any[]> {
    return this.engine.executeNodes(nodes, true);
  }
}
